import { useState, useCallback } from 'react';

import { ApiKeysService } from '@app/api/api-keys';

export function useKeyDeletion() {
  const [pendingDeletions, setPendingDeletions] = useState<Set<string>>(new Set());
  const [deletingKeys, setDeletingKeys] = useState<Set<string>>(new Set());

  const deleteKey = useCallback(
    async (id: string): Promise<boolean> => {
      // If not pending deletion, add to pending first
      if (!pendingDeletions.has(id)) {
        setPendingDeletions((current) => new Set(current).add(id));
        return false;
      }

      // Otherwise, proceed with deletion
      setDeletingKeys((current) => new Set(current).add(id));
      try {
        await ApiKeysService.delete(id);
        setPendingDeletions((current) => {
          const updated = new Set(current);
          updated.delete(id);
          return updated;
        });
        return true;
      } finally {
        setDeletingKeys((current) => {
          const updated = new Set(current);
          updated.delete(id);
          return updated;
        });
      }
    },
    [pendingDeletions],
  );

  const cancelDelete = useCallback((id: string) => {
    setPendingDeletions((current) => {
      const updated = new Set(current);
      updated.delete(id);
      return updated;
    });
  }, []);

  return {
    pendingDeletions,
    deletingKeys,
    deleteKey,
    cancelDelete,
  };
}
